import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const { t } = useTranslation();

  const faqs = [
    { q: t('faq.q1'), a: t('faq.a1') },
    { q: t('faq.q2'), a: t('faq.a2') },
    { q: t('faq.q3'), a: t('faq.a3') },
    { q: t('faq.q4'), a: t('faq.a4') },
    { q: t('faq.q5'), a: t('faq.a5') },
    { q: t('faq.q6'), a: t('faq.a6') },
    { q: t('faq.q7'), a: t('faq.a7') },
    { q: t('faq.q8'), a: t('faq.a8') },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <span className="text-xs font-semibold text-blue-600 tracking-widest uppercase mb-3 block">{t('faq.badge')}</span>
          <h2 className="text-4xl font-bold text-gray-900 mb-3" style={{ fontFamily: "'Inter', sans-serif" }}>
            {t('faq.title')}
          </h2>
          <p className="text-sm text-gray-500">
            {t('faq.desc')}
          </p>
        </div>

        <div className="flex flex-col gap-2.5">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`rounded-xl border transition-all duration-200 overflow-hidden ${
                openIndex === i ? 'border-blue-200 bg-blue-50/30' : 'border-gray-100 bg-white'
              }`}
            >
              <button
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className={`text-sm font-medium pr-4 leading-snug ${openIndex === i ? 'text-blue-700' : 'text-gray-900'}`}>
                  {faq.q}
                </span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className={`text-blue-500 text-lg transition-transform duration-200 ${openIndex === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5">
                  <p className="text-sm text-gray-500 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
